import { Fragment, useContext, useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../Assets/images/newLogo.png";
import avatar from "../../Assets/images/profile1.png"
import { UserContext } from "../../Context/UserContext.js";
import { CartContext } from "../../Context/CartContext.js";
import getGreeting from "../../Utilities/getGreeting.js"
import "./navbar.css"
import { logOut } from "../../Utilities/logOut.js";
import { OrderContext } from "../../Context/OrderContext.js";

export default function Navbar() {
   const navigate = useNavigate();
   const location = useLocation();
   const [scroll, setScroll] = useState(0);
   const [click, setClick] = useState(true);
   const [notification, setNotification] = useState([])
   const { loggedUser, userToken, admin, moderator, completeInfoUser } = useContext(UserContext);
   const totalUserInfo = useContext(UserContext);
   const { cart, orderCount } = useContext(CartContext);
   const { talabatCount, getTalabatCount } = useContext(OrderContext);

   // Check if current route should show top navbar
   const topNavbarRoutes = ['/about', '/login', '/contactus', '/contact', '/', "/PrivacyPolicy"];
   const showTopNavbar = topNavbarRoutes.includes(location.pathname);

   console.log(notification)

   const closeMobileNavbar = () => {
      const navbarCollapse = document.querySelectorAll('.navbar-collapse.show');
      navbarCollapse.forEach((navbar) => {
         navbar.classList.remove('show');
      });
   };

   useEffect(() => {
      if (userToken) {
         getTalabatCount();
      }
   }, []);



   //& Handle Scroll Display Navbar :
   window.onscroll = function (e) {
      if (window.scrollY > scroll) {
         e.target.getElementById("navbar").style.top = "-100px"
      } else {
         e.target.getElementById("navbar").style.top = "0px"
      }
      setScroll(window.scrollY)
   }


   const handleButtonDisplay = () => {
      setClick(!click)
   }

   let removeNotification = (count) => {
      console.log(count);
   }



   //& Handle Log Out :
   function handleLogOut() {
      logOut(navigate, totalUserInfo);
      closeMobileNavbar();
   }


   return (
      <Fragment>


         <div className="navbar-other-media">
            <nav className=" navbar navbar-expand bgBlack p-0 main_navbar bg-body-tertiary fixed-top mb-5 pt-1" id="navbar">
               <div className="container p-0">
                  <Link className="navbar-brand text-white div_logo " style={{ height: "67px" }} to="/home"><img src={logo} alt="logo" className="w-100 h-100 logo " /></Link>
                  {userToken && loggedUser ? <>
                     {admin || moderator ? <>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                           <ul className="navbar-nav ms-auto mb-lg-0 ">
                              <li className="nav-item">
                                 <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                    aria-current="page" to="/dashBoard/"><i className="fa-solid fa-house"></i> <span >Home</span></NavLink>
                              </li>


                              <li className="nav-item">
                                 <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                    to="/dashBoard/orderDashboard"><i className="fa-solid fa-address-card"></i><span >DashBoard</span></NavLink>
                              </li>
                           </ul>

                           <ul className="navbar-nav ms-auto mb-lg-0 d-flex align-items-center justify-content-between">
                              <Link to="/dashBoard/Setting"><li className="text-white fs-5"><i className="fa-solid fa-gear"></i></li></Link>
                              <div className="d-inline-block position-relative div_imgCover">
                                 {notification.length ? <span className="position-absolute notification_admin p-1">{notification.length}</span> : ""}
                                 <i onClick={() => { handleButtonDisplay() }} className="fa-regular fa-bell fa-xl"></i>
                              </div>

                              <div className="d-inline-block position-relative div_imgCover">
                                 {completeInfoUser ? "" : <span className="position-absolute completeUser  p-1"></span>}
                                 <Link to="/userProfile">
                                    <img
                                       src={loggedUser.imgCover || avatar}
                                       onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = avatar;
                                       }}
                                       className="imgCover"
                                       alt="Cover"
                                    />
                                 </Link>
                              </div>
                              <button onClick={() => { handleLogOut() }} className="btn btn_logOut me-1">LogOut</button>

                              <li className="nav-item">
                                 <Link to="/morePage">
                                    <i className="fa-solid fa-ellipsis-vertical fs-4 text-white"></i>
                                 </Link>
                              </li>

                           </ul>
                        </div>
                     </> : <>

                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                           <ul className="navbar-nav ms-auto  mb-lg-0 ">
                              <li className="nav-item">
                                 <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                    aria-current="page" to="/home"><i className="fa-solid fa-house xxx"></i> <span >Home</span></NavLink>
                              </li>

                              <li className="nav-item">
                                 <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                    to="/price"><i className="fa-solid fa-layer-group"></i><span >price</span></NavLink>
                              </li>

                              <li className="nav-item position-relative">
                                 <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                    to="/allOrderLoggedUser">
                                    <i className="fa-solid fa-address-card"></i>
                                    <span> Orders </span>
                                    {talabatCount > 0 && (
                                       <span
                                          style={{ top: "25%" }}
                                          className="position-absolute start-100 translate-middle badge rounded-pill bg-danger">
                                          {talabatCount}
                                       </span>
                                    )}
                                 </NavLink>
                              </li>


                              <li className="nav-item">
                                 <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                    to="/contact"><i className="fa-solid fa-address-card"></i><span >Contact</span></NavLink>
                              </li>
                           </ul>

                           <ul className="navbar-nav ms-auto mb-lg-0 d-flex align-items-center justify-content-between">

                              <li className="">
                                 <Link className="position-relative text-white" to="/cart">
                                    {cart?.cartItems?.length ? <span className="notification_cart bg-opacity-25 position-absolute text-white">{cart?.cartItems?.length}</span> : ""}
                                    <i className="fa-solid fa-cart-shopping text-white user-cart"></i>
                                 </Link>
                              </li>

                              <div className="d-inline-block position-relative div_imgCover">
                                 {completeInfoUser ? "" : <span className="position-absolute completeUser  p-1"></span>}
                                 <Link to="/userProfile" className="text-white">
                                    <img
                                       src={loggedUser.imgCover || avatar}
                                       onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = avatar;
                                       }}
                                       className="imgCover"
                                       alt="Cover"
                                    />
                                 </Link>
                              </div>

                              <button onClick={() => { handleLogOut() }} className="btn btn text-white me-1">الخروج<i className="fa-solid fa-right-from-bracket mx-2"></i></button>


                              <li className="nav-item">
                                 <Link to="/morePage">
                                    <i className="fa-solid fa-ellipsis-vertical fs-4 text-white"></i>
                                 </Link>
                              </li>
                           </ul>
                        </div>
                     </>
                     }
                  </> : <>
                     <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto  mb-lg-0 ">

                           <li className="nav-item">
                              <NavLink className="nav-link d-flex align-items-center gap-2" onClick={closeMobileNavbar}
                                 to="/login">
                                 <span className="text-white fs-6">للتسجيل و الحجز</span>
                                 <i className="fas fa-user-plus text-white fs-6"></i>
                              </NavLink>
                           </li>

                           <li className="nav-item">
                              <NavLink className="nav-link d-flex align-items-center gap-2" onClick={closeMobileNavbar}
                                 to="/contact">
                                 <span className="text-white fs-6">تواصل معنا</span>
                                 <i className="fa-solid fa-address-card text-white fs-6"></i>
                              </NavLink>
                           </li>

                           <li className="nav-item">
                              <NavLink className="nav-link d-flex align-items-center gap-2" onClick={closeMobileNavbar}
                                 to="/about">
                                 <span className="text-white fs-6">من نحن</span>
                                 <i className="fas fa-info-circle text-white fs-6"></i>
                              </NavLink>
                           </li>
                           <li className="nav-item">
                              <NavLink className="nav-link d-flex align-items-center gap-2" onClick={closeMobileNavbar}
                                 to="/">
                                 <span className="text-white fs-6">الرئيسية </span>
                                 <i className="fa-solid fa-house text-white fs-6"></i>
                              </NavLink>
                           </li>
                        </ul>

                        <ul className="navbar-nav ms-auto mb-lg-0 d-flex align-items-center justify-content-between">
                        </ul>
                     </div>
                  </>
                  }

               </div>

               {notification.length ? <>
                  <div className="notificationAdmin" style={{ display: click ? 'none' : "block" }} >
                     <h4 className="p-1 bg-white rounded-1 text-center">Notification</h4>
                     <div className="p-1 bg-white rounded-2  notification-box">
                        {notification.map((ele) => {
                           return (
                              <p className="my-2  border-bottom border-2 pb-2" key={ele.count}>
                                 <span className="text-success mx-2">
                                    <i className="fa-solid fa-folder-plus"></i>
                                 </span>
                                 {ele.type === "addOrder" ? `New Order is Added By ${ele.sender}` : ""}
                                 <i onClick={() => { removeNotification(ele.count) }} className="fa-solid fa-xmark text-danger  ms-4 exist_Notification"></i>
                              </p>
                           )
                        })}
                     </div>
                  </div>
               </> : <>
                  <div className="notificationAdmin" style={{ display: click ? 'none' : "block" }} >
                     <h4 className="p-1 bg-white rounded-1 text-center">Notification</h4>
                     <div className="p-1 bg-white rounded-2">
                        <p className="text-center fw-bold text-danger">Not Found New Notification</p>
                     </div>
                  </div>
               </>}

            </nav>
         </div>


         <div className="navbar-mobile-bottom bgBlack">
            {userToken && loggedUser ? <>
               {admin || moderator ? <>
                  {showTopNavbar ? (
                     /* Top Navbar with Burger Menu - Admin */
                     <nav className="navbar navbar-expand-lg bgBlack" >
                        <div className="container-fluid">
                           {/* Logo */}
                           <Link className="navbar-brand" to="/home">
                              <img src={logo} alt="logo" style={{ height: "50px" }} />
                           </Link>

                           {/* Burger Menu Button */}
                           <button
                              className="navbar-toggler border-0"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#mobileMenuAdmin"
                              aria-controls="mobileMenuAdmin"
                              aria-expanded="false"
                              aria-label="Toggle navigation"
                           >
                              <i className="fa-solid fa-bars text-white fs-3"></i>
                           </button>

                           {/* Collapsible Menu */}
                           <div className="collapse navbar-collapse" id="mobileMenuAdmin">
                              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                       to="/dashBoard/">
                                       <i className="fa-solid fa-house-user me-2"></i>
                                       Home
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white position-relative" onClick={closeMobileNavbar}
                                       to="/allOrderLoggedUser">
                                       <i className="fa-solid fa-truck me-2"></i>
                                       الطلبات
                                       {talabatCount > 0 && (
                                          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                             {talabatCount}
                                          </span>
                                       )}
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                       to="/userProfile">
                                       <i className="fa-solid fa-user me-2"></i>
                                       Profile
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                       to="/morePage">
                                       <i className="fa-solid fa-ellipsis me-2"></i>
                                       More
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <button onClick={handleLogOut} className="btn btn-outline-light mt-2 w-100">
                                       <i className="fa-solid fa-right-from-bracket me-2"></i>
                                       Logout
                                    </button>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </nav>
                  ) : (
                     <>
                        {/* Header */}
                        <header className="mx-1 p-2 pt-4 bgBlack  text-white  rounded text-center">
                           <div className='row  align-items-center flex-column'>

                              <div className='p-0'>
                                 <div>
                                    <Link to="/home">
                                       <h1 className="h5 m-0">Admin Dashboard</h1>
                                    </Link>
                                 </div>


                                 <div className="">
                                    <p className='m-0 ps-3'>{getGreeting()}</p>
                                    <p className='m-0 text-name'>{loggedUser?.name?.toLowerCase().split(" ").map(word => word.charAt(0)?.toUpperCase() + word.slice(1)).slice(0, 2).join(" ")}</p>
                                 </div>


                                 <div className="div-mobile-imgCover">
                                    <Link to="/userProfile">
                                       <img
                                          src={loggedUser.imgCover || avatar}
                                          onError={(e) => {
                                             e.target.onerror = null;
                                             e.target.src = avatar;
                                          }}
                                          className="w-100"
                                          alt="Cover"
                                       />
                                    </Link>
                                 </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center">
                                 <div className='p-0'>
                                    <Link to="#"><i className="fa-regular fa-bell mx-3 fs-4"></i></Link>
                                    <Link to="https://wa.me/201066991090"><i className="fa-brands fa-whatsapp mx-3  fs-4"></i></Link>
                                 </div>

                                 <div className='p-0'>
                                    <Link to="#"><i className="fa-solid fa-phone-volume mx-3  fs-4"></i></Link>
                                    <Link to="#"><i className="fa-solid fa-calendar-days mx-3  fs-4"></i></Link>
                                 </div>
                              </div>

                           </div>
                        </header>

                        {/* Navbar Mobile Position Bottom  */}
                        <nav className="navbar navbar-mobile navbar-dark bg-dark fixed-bottom text-white">
                           <div className="container-fluid d-flex justify-content-evenly">


                              <Link to="/allOrderLoggedUser" className="cart-icon position-relative">
                                 <i className="fa-solid fa-truck"></i>
                                 {talabatCount > 0 && (
                                    <span className="dotRedOrder position-absolute d-flex justify-content-center align-items-center">
                                       {talabatCount}
                                    </span>
                                 )}
                                 <p className="m-0">الطلبات</p>
                              </Link>



                              <Link to="/dashBoard/" className="cart-icon">
                                 <i className="fa-solid fa-house-user  fs-2 "></i>
                                 <p className="m-0">Home</p>
                              </Link>

                              <Link to="/morePage" className="cart-icon">
                                 <i className="fa-solid fa-ellipsis "></i>
                                 <p className="m-0">More</p>
                              </Link>

                           </div>
                        </nav>
                     </>
                  )}
               </> : <>
                  {showTopNavbar ? (
                     /* Top Navbar with Burger Menu - Regular User */
                     <nav className="navbar navbar-expand-lg bgBlack " >
                        <div className="container-fluid">
                           {/* Logo */}
                           <Link className="navbar-brand" to="/home">
                              <img src={logo} alt="logo" style={{ height: "50px" }} />
                           </Link>

                           {/* Burger Menu Button */}
                           <button
                              className="navbar-toggler border-0"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#mobileMenuUser"
                              aria-controls="mobileMenuUser"
                              aria-expanded="false"
                              aria-label="Toggle navigation"
                           >
                              <i className="fa-solid fa-bars text-white fs-3"></i>
                           </button>

                           {/* Collapsible Menu */}
                           <div className="collapse navbar-collapse" id="mobileMenuUser" dir="rtl">
                              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                       to="/home">
                                       <i className="fa-solid fa-house-user me-2"></i>
                                       الرئيسية
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white position-relative" onClick={closeMobileNavbar}
                                       to="/cart">
                                       <i className="fa-solid fa-cart-plus me-2"></i>
                                       السلة
                                       {cart?.cartItems?.length > 0 && (
                                          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                             {cart?.cartItems?.length}
                                          </span>
                                       )}
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white position-relative" onClick={closeMobileNavbar}
                                       to="/allOrderLoggedUser">
                                       <i className="fa-solid fa-truck me-2"></i>
                                       الطلبات
                                       {talabatCount > 0 && (
                                          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                             {talabatCount}
                                          </span>
                                       )}
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                       to="#">
                                       <i className="fa-solid fa-gift me-2"></i>
                                       العروض
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                       to="/userProfile">
                                       <i className="fa-solid fa-user me-2"></i>
                                       الملف الشخصي
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <NavLink className="nav-link text-white" onClick={closeMobileNavbar}
                                       to="/morePage">
                                       <i className="fa-solid fa-ellipsis me-2"></i>
                                       المزيد
                                    </NavLink>
                                 </li>
                                 <li className="nav-item">
                                    <button onClick={handleLogOut} className="btn btn-outline-light mt-2 w-100">
                                       <i className="fa-solid fa-right-from-bracket me-2"></i>
                                       الخروج
                                    </button>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </nav>
                  ) : (
                     <>
                        {/* Header */}
                        <header className="m-1 p-2 pt-4 bgBlack text-white  rounded text-center">
                           <div className='row  align-items-center flex-column'>

                              <div className='p-0'>
                                 <div>
                                    <Link to="/home">
                                       <h3 className="header-title-text m-0 d-flex justify-content-center  gap-1">
                                          <span className="text-white">SMART</span>
                                          <span className="ps-1 ">TREND</span>
                                       </h3>
                                    </Link>
                                 </div>


                                 <div className="">
                                    <p className='m-0 ps-3 fs-4'>{getGreeting()}</p>
                                    <p className='m-0 text-name'>{loggedUser?.name?.toLowerCase().split(" ").map(word => word.charAt(0)?.toUpperCase() + word.slice(1)).slice(0, 2).join(" ")}</p>
                                 </div>


                                 <div className="div-mobile-imgCover mt-2">
                                    <Link to="/userProfile">
                                       <img
                                          src={loggedUser.imgCover || avatar}
                                          onError={(e) => {
                                             e.target.onerror = null;
                                             e.target.src = avatar;
                                          }}
                                          className="w-100 text-white"
                                          alt="Cover"
                                       />
                                    </Link>
                                 </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center">
                                 <div className='p-0'>
                                    <Link to="https://wa.me/201066991090"><i className="fa-brands fa-whatsapp mx-3 text-white fs-3"></i></Link>
                                 </div>

                                 <div className='p-0'>
                                    <Link to="#"><i className="fa-solid fa-phone-volume mx-3  fs-3"></i></Link>
                                    <Link to="/allOrderLoggedUser"><i className="fa-solid fa-calendar-days mx-3 text-white fs-3"></i></Link>
                                 </div>
                              </div>

                           </div>
                        </header>

                        {/* Navbar Mobile Position Bottom  */}
                        <nav className="navbar navbar-mobile  bgBlack fixed-bottom text-white ">
                           <div className="container-fluid d-flex justify-content-evenly">

                              <Link to="#" className="cart-icon">
                                 <i className="fa-solid fa-gift"></i>
                                 <p className="m-0">العروض</p>
                              </Link>


                              <Link to="/allOrderLoggedUser" className="cart-icon position-relative" style={{ width: "fit-content" }}>
                                 <i className="fa-solid fa-truck"></i>
                                 {talabatCount > 0 && (
                                    <span
                                       className="dotRedOrder position-absolute d-flex justify-content-center align-items-center"
                                       style={{ top: "-10px", right: "-5px" }}
                                    >
                                       {talabatCount}
                                    </span>
                                 )}
                                 <p className="m-0">الطلبات</p>
                              </Link>



                              <Link to="/home" className="cart-icon">
                                 <i className="fa-solid fa-house-user  fs-2 "></i>
                                 <p className="m-0">الرئيسية</p>
                              </Link>


                              <Link to="/cart" className="cart-icon position-relative" style={{ width: "fit-content" }}>
                                 <i className="fa-solid fa-cart-plus"></i>
                                 <p className="m-0">السلة</p>

                                 {cart?.cartItems?.length > 0 && (
                                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill dotRedOrder">
                                       {cart?.cartItems?.length}
                                    </span>
                                 )}
                              </Link>


                              <Link to="/morePage" className="cart-icon">
                                 <i className="fa-solid fa-ellipsis "></i>
                                 <p className="m-0">المزيد</p>
                              </Link>

                           </div>
                        </nav>
                     </>
                  )}
               </>}
            </> : <>
               {showTopNavbar ? (
                  /* Top Navbar with Burger Menu - Guest User */
                  <nav className="navbar navbar-expand-lg bgBlack" >
                     <div className="container-fluid">
                        {/* Logo */}
                        <Link className="navbar-brand" to="/">
                           <img src={logo} alt="logo" style={{ height: "50px" }} />
                        </Link>

                        {/* Burger Menu Button */}
                        <button
                           className="navbar-toggler border-0"
                           type="button"
                           data-bs-toggle="collapse"
                           data-bs-target="#mobileMenuGuest"
                           aria-controls="mobileMenuGuest"
                           aria-expanded="false"
                           aria-label="Toggle navigation"
                        >
                           <i className="fa-solid fa-bars text-white fs-3"></i>
                        </button>

                        {/* Collapsible Menu */}
                        <div className="collapse navbar-collapse" id="mobileMenuGuest">
                           <ul className="navbar-nav ms-auto mb-2 mb-lg-0" dir="rtl">
                              <li className="nav-item">
                                 <NavLink className="nav-link text-white d-flex gap-2 align-items-center" onClick={closeMobileNavbar}
                                    to="/">
                                    <i className="fa-solid fa-house-user me-2"></i>
                                    الرئيسية
                                 </NavLink>
                              </li>
                              <li className="nav-item">
                                 <NavLink className="nav-link text-white d-flex gap-2 align-items-center" onClick={closeMobileNavbar}
                                    to="/contact">
                                    <i className="fa-solid fa-address-card me-2"></i>
                                    تواصل معنا
                                 </NavLink>
                              </li>
                              <li className="nav-item">
                                 <NavLink className="nav-link text-white d-flex gap-2 align-items-center" onClick={closeMobileNavbar}
                                    to="/about">
                                    <i className="fas fa-info-circle me-2"></i>
                                    من نحن
                                 </NavLink>
                              </li>
                              <li className="nav-item">
                                 <NavLink className="nav-link text-white d-flex gap-2 align-items-center" onClick={closeMobileNavbar}
                                    to="/login">
                                    <i className="fas fa-sign-in-alt me-2"></i>
                                    تسجيل الدخول
                                 </NavLink>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </nav>
               ) : (
                  /* Bottom Navbar - Guest User */
                  <nav className="navbar navbar-mobile  bgBlack fixed-bottom text-white" style={{ marginTop: '80px' }}>
                     <div className="container-fluid d-flex justify-content-evenly">
                        <Link to="/about" className="cart-icon">
                           <i className="fas fa-info-circle text-white fs-2"></i>
                           <p className="text-white m-0">من نحن</p>
                        </Link>

                        <Link to="/contact" className="cart-icon">
                           <i className="fa-solid fa-address-card text-white fs-2"></i>
                           <p className="text-white m-0" style={{ fontSize: "13px" }}>تواصل معنا</p>
                        </Link>

                        <Link to="/home" className="cart-icon">
                           <i className="fa-solid fa-house-user fs-2"></i>
                           <p className="m-0">الرئيسية</p>
                        </Link>
                     </div>
                  </nav>
               )}
            </>
            }
         </div>

      </Fragment>
   )
}